import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LayoutService } from '../services/layout.service';
import { url } from 'inspector';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class ServicePermissionsGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      this.authService.getUserLogged().subscribe({
        next: (user: UserModel) => {
          if (user) {
            const urlservice = route.url[0].path.charAt(0) == '/' ? route.url[0].path : '/' + route.url[0].path;
            const permission = user.client.services.find(service => {
              if (service.path) {
                return service.path.includes(urlservice);
              }
              return false;
            });
            if (!permission) {
              this.router.navigate(['/dashboard']);
              this.toastr.error('', 'Permission denied');
              resolve(false);
            }
            resolve(true);
          }
        }, // Resolve with the first emitted value
        error: err => reject(err), // Reject if there is an error
        complete: () => {
          // Optionally handle completion if needed, though resolve will be called on the first emission
        },
      });
    });
  }
}
